import { AppRoute } from 'src/core/AppRoute';
import ImgAbo from 'src/resources/img-abo.png';
import ImgMission from 'src/resources/img-mission.jpg';
import ImgOffice from 'src/resources/img-office.jpg';
import ImgPrivate from 'src/resources/img-private.jpg';
import ImgQuality from 'src/resources/img-quality-roast.png';
import ImgCoffeeBeans from 'src/resources/img-store-coffee-beans.png';
import ImgCoffeeTabs from 'src/resources/img-store-coffee-tabs.png';
import ImgMachines from 'src/resources/img-store-machines.png';
import ImgSustainability from 'src/resources/img-sustainability.jpg';
import ThumbImgAbo from 'src/resources/thumbs/img-abo.png';
import ThumbImgMission from 'src/resources/thumbs/img-mission.jpg';
import ThumbImgOffice from 'src/resources/thumbs/img-office.jpg';
import ThumbImgPrivate from 'src/resources/thumbs/img-private.jpg';
import ThumbImgQuality from 'src/resources/thumbs/img-quality-roast.png';
import ThumbImgCoffeeBeans from 'src/resources/thumbs/img-store-coffee-beans.png';
import ThumbImgCoffeeTabs from 'src/resources/thumbs/img-store-coffee-tabs.png';
import ThumbImgMachines from 'src/resources/thumbs/img-store-machines.png';
import ThumbImgSustainability from 'src/resources/thumbs/img-sustainability.jpg';

export const ROUTE_WELCOME = new AppRoute('/welcome', 'welcome');

export const ROUTE_WELCOME_CONTACT = ROUTE_WELCOME.sub('contact', 'welcome_contact');

export const ROUTE_WELCOME_INFO = ROUTE_WELCOME.sub('info', 'welcome_info');

/* Info Routes */
export const ROUTE_WELCOME_INFO_COFFEE_EXPERT = ROUTE_WELCOME_INFO.sub('coffee-expert', 'welcome_info_coffee_expert', {
    image: ImgOffice,
    thumbnail: ThumbImgOffice,
});
export const ROUTE_WELCOME_INFO_COFFEE_BEANS = ROUTE_WELCOME_INFO.sub('coffee-beans', 'welcome_info_coffee_beans', {
    image: ImgCoffeeBeans,
    thumbnail: ThumbImgCoffeeBeans,
});
export const ROUTE_WELCOME_INFO_COFFEE_TABS = ROUTE_WELCOME_INFO.sub('coffee-tabs', 'welcome_info_coffee_tabs', {
    image: ImgCoffeeTabs,
    thumbnail: ThumbImgCoffeeTabs,
});
export const ROUTE_WELCOME_INFO_CUSTOMER_VOICES = ROUTE_WELCOME_INFO.sub(
    'customer-voices',
    'welcome_info_customer_voices',
    {
        image: ImgPrivate,
        thumbnail: ThumbImgPrivate,
    }
);
export const ROUTE_WELCOME_INFO_MACHINE_INSTRUCTIONS = ROUTE_WELCOME_INFO.sub(
    'machine-instructions',
    'welcome_info_machine_instructions',
    {
        image: ImgMachines,
        thumbnail: ThumbImgMachines,
    }
);
export const ROUTE_WELCOME_INFO_SUS = ROUTE_WELCOME_INFO.sub('sustainability', 'welcome_info_sustainability', {
    image: ImgSustainability,
    thumbnail: ThumbImgSustainability,
});

export const ROUTE_WELCOME_INFO_SUS_BEAN_MIXTURE = ROUTE_WELCOME_INFO_SUS.sub(
    'bean-mixture',
    'welcome_info_sustainability_bean_mixture',
    {
        image: ImgCoffeeBeans,
        thumbnail: ThumbImgCoffeeBeans,
    }
);
export const ROUTE_WELCOME_INFO_SUS_QUALITY = ROUTE_WELCOME_INFO_SUS.sub(
    'quality',
    'welcome_info_sustainability_quality',
    {
        image: ImgQuality,
        thumbnail: ThumbImgQuality,
    }
);
export const ROUTE_WELCOME_INFO_SUS_CULTIVATION = ROUTE_WELCOME_INFO_SUS.sub(
    'cultivation',
    'welcome_info_sustainability_cultivation',
    {
        image: ImgMission,
        thumbnail: ThumbImgMission,
    }
);
export const ROUTE_WELCOME_INFO_SUS_ROASTING = ROUTE_WELCOME_INFO_SUS.sub(
    'roasting',
    'welcome_info_sustainability_roasting',
    {
        image: ImgQuality,
        thumbnail: ThumbImgQuality,
    }
);

export const GROUP_WELCOME_INFO: AppRoute[] = [
    ROUTE_WELCOME_CONTACT,
    ROUTE_WELCOME_INFO_COFFEE_BEANS,
    ROUTE_WELCOME_INFO_COFFEE_TABS,
    ROUTE_WELCOME_INFO_COFFEE_EXPERT,
    ROUTE_WELCOME_INFO_CUSTOMER_VOICES,
    ROUTE_WELCOME_INFO_MACHINE_INSTRUCTIONS,
    // ROUTE_WELCOME_INFO_SUS,
];

export const GROUP_WELCOME_INFO_SUS: AppRoute[] = [
    ROUTE_WELCOME_INFO_SUS_BEAN_MIXTURE,
    ROUTE_WELCOME_INFO_SUS_QUALITY,
    ROUTE_WELCOME_INFO_SUS_CULTIVATION,
    ROUTE_WELCOME_INFO_SUS_ROASTING,
];

/* Store Routes */

export const ROUTE_WELCOME_STORE = ROUTE_WELCOME.sub('store', 'welcome_store');

export const ROUTE_WELCOME_STORE_PRODUCT_ABO_GROUP = ROUTE_WELCOME_STORE.sub('abo', 'welcome_store_product_abo_group', {
    thumbnail: ThumbImgAbo,
    image: ImgAbo,
});

export const ROUTE_WELCOME_STORE_PRODUCT_GROUP = ROUTE_WELCOME_STORE.sub(
    ':productGroupSlug',
    'welcome_store_product_group'
);

export const ROUTE_WELCOME_STORE_PRODUCT_ABO_DETAILS = ROUTE_WELCOME_STORE_PRODUCT_GROUP.sub(
    ':id',
    'welcome_store_product_details'
);

export const ROUTE_WELCOME_STORE_PRODUCT_GROUP_SELECT = ROUTE_WELCOME_STORE_PRODUCT_GROUP.sub(
    'select',
    'welcome_store_product_group_select'
);

export const ROUTE_WELCOME_STORE_PRODUCT_DETAILS = ROUTE_WELCOME_STORE_PRODUCT_GROUP.sub(
    ':id',
    'welcome_store_product_details'
);

export const ROUTE_WELCOME_STORE_SUB_PRODUCT_DETAILS = ROUTE_WELCOME_STORE_PRODUCT_DETAILS.sub(
    ':subid',
    'welcome_store_sub_product_details'
);

/* Customer Type */
export const ROUTE_WELCOME_CUSTOMER_TYPE = ROUTE_WELCOME.sub('customer-type', 'welcome_customer_type');

/* Register Routes */
export const ROUTE_WELCOME_REGISTER = ROUTE_WELCOME.sub('register', 'welcome_register');
// offer invite (option 3): the public token→offer page the invite mail links
export const ROUTE_WELCOME_OFFER = ROUTE_WELCOME.sub('angebot', 'welcome_offer');

/* Cart Routes */
export const ROUTE_WELCOME_CART = ROUTE_WELCOME.sub('cart', 'welcome_cart');

/* Order Complete */
export const ROUTE_WELCOME_ORDER_COMPLETE = ROUTE_WELCOME.sub('order-complete', 'welcome_order_complete');

/* Register Complete */
export const ROUTE_WELCOME_REGISTER_COMPLETE = ROUTE_WELCOME.sub('register-complete', 'welcome_register_complete');
